import React, { useState } from 'react';

function QuestionRenderer({ question, onChange }) {
  const [value, setValue] = useState("");

  const handleChange = (val) => {
    setValue(val);
    onChange(question.questionId, val);
  };

  const isNotes = question.meta?.isNoteField;

  const renderYesNo = () => (
    <div className="responses">
      {["Yes", "No"].map((option) => (
        <label
          key={option}
          className={`response-box ${value === option ? "selected" : ""}`}
          onClick={() => handleChange(option)}
        >
          <input
            type="radio"
            name={question.questionId}
            value={option}
            checked={value === option}
            onChange={() => handleChange(option)}
            style={{ display: "none" }}
          />
          {option}
        </label>
      ))}
    </div>
  );

  const renderMultiSelect = () => (
    <div className="responses">
      {question.options.map((option) => (
        <label
          key={option}
          className={`response-box ${value?.includes(option) ? "selected" : ""}`}
          onClick={() => {
            const isSelected = value?.includes(option);
            const updated = isSelected
              ? value.filter((v) => v !== option)
              : [...(value || []), option];
            handleChange(updated);
          }}
        >
          <input
            type="checkbox"
            checked={value?.includes(option)}
            style={{ display: "none" }}
            readOnly
          />
          {option}
        </label>
      ))}
    </div>
  );

  const renderSelect = () => (
    <select
      value={value || ""}
      onChange={(e) => handleChange(e.target.value)}
    >
      <option value="" disabled>Select one...</option>
      {question.options.map((opt) => (
        <option key={opt} value={opt}>{opt}</option>
      ))}
    </select>
  );

  const renderDynamicList = () => (
    <div>
      {(value || [""]).map((val, i) => (
        <input
          key={i}
          type="text"
          value={val}
          onChange={(e) => {
            const updated = [...(value || [""])];
            updated[i] = e.target.value;
            handleChange(updated);
          }}
        />
      ))}
      <button
        type="button"
        className="add-item-btn"
        onClick={() => handleChange([...(value || []), ""])}
      >
        Add Item
      </button>
    </div>
  );

  const renderTextInput = () =>
    isNotes ? (
      <textarea
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        className="notes-box"
        placeholder="Add any additional notes here..."
      />
    ) : (
      <input
        type="text"
        value={value}
        onChange={(e) => handleChange(e.target.value)}
      />
    );

  return (
    <div className="question-block">
      {question.guidance && <div className="guidance">{question.guidance}</div>}

      {(() => {
        switch (question.type) {
          case "yesno":
            return renderYesNo();
          case "multiselect":
            return renderMultiSelect();
          case "select":
            return renderSelect();
          case "dynamic_list":
            return renderDynamicList();
          case "text":
          default:
            return renderTextInput();
        }
      })()}
    </div>
  );
}

export default QuestionRenderer;
